import { Service } from '@tino-frontend/adapters'
import { PaymentObligationsResponse, PaymentObligationsFilters } from '@types'

export class PaymentObligationsService {
  constructor(private readonly http: Service) {}

  list(
    filters: PaymentObligationsFilters
  ): Promise<PaymentObligationsResponse> {
    return this.http.get(
      `/v1/company/${filters.company_id}/payment-obligations`,
      {
        params: filters,
      }
    )
  }
}
